import React from "react";

const DetailsCard = ({ title, value }) => {
  return (
    <div className="bg-card p-2 shadow-card border-main border-[2px]">
      <h3 className="text-muted text-sm font-medium">{title}</h3>
      <p className={`text-xl font-bold `}>{value}</p>
    </div>
  );
};

export default DetailsCard;
